import { createResetStateMutation } from '@/helpers';
import { bodyEmail } from '../helpers';
import { getInitialStateBsa } from './state';

export const updateComentario = (state, payload) => {
   state.comentario = payload;
};

export const updateSeguimiento = (state, { key, value }) => {
   state.seguimiento[key] = value;
};

export const setCompaniesBsa = (state, payload) => {
   state.companias = payload;
};

export const cleanCompaniasAsignadas = (state) => {
   state.companias = {};
};

export const setSuscriptores = (state, payload) => {
   state.suscriptores = payload;
};

export const setSuscriptor = (state, payload) => {
   state.suscriptor = payload; // Actualiza con el objeto seleccionado
};

export const setEstados = (state, payload) => {
   state.estados = payload;
};

export const setEstado = (state, payload) => {
   state.estado = payload;
};

export const updateMail = (state, { key, value }) => {
   state.mail[key] = value;
};

export const cleanEmail = (state) => {
   state.mail.asunto = null;
   state.mail.cuerpo = null;
};

export const resetEmailState = (state, { usuario, id_seccion }) => {
   state.mail = bodyEmail(usuario, id_seccion);
};

export const updateCompaniasAsignadas = (state, payload) => {
   state.companiasAsignadas = payload;
};
export const setFechaResolucion = (state, payload) => {
   state.fecha_resolucion = payload;
};
export const setCasoAsignado = (state, payload) => {
   state.casoAsignado = payload;
};
export const setCompaniaSeguimientoBsa = (state, payload) => {
   state.casoAsignado.compania = payload;
};
export const setComentarioSeguimientoBsa = (state, payload) => {
   state.casoAsignado.comentario = payload;
};

export const setComentario = (state, payload) => {
   state.comentario = payload;
};

export const setAbms = (state, payload) => {
   state.abms = payload;
};

export const setOptionsAbm = (state, payload) => {
   state.optionsAbm = payload;
};

export const setDescuentos = (state, payload) => {
   state.descuentos = payload;
};
export const setGrupos = (state, payload) => {
   state.grupos = payload;
};
export const setEmpresas = (state, payload) => {
   state.empresas = payload;
};
export const setCompanias = (state, payload) => {
   state.companias = payload;
};
export const setDescuento = (state, payload) => {
   state.descuento = payload;
};
export const updateDescuento = (state, { key, value }) => {
   state.descuento[key] = value;
};

export const setCoberturas = (state, payload) => {
   state.coberturas = payload;
};
export const setSecciones = (state, payload) => {
   state.secciones = payload;
};

export const setEmpresaCompaniaSeccion = (state, payload) => {
   state.empresaCompaniaSeccion = payload || [];
};

export const resetState = createResetStateMutation(getInitialStateBsa);
